import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  iconTile: {
    width: 40,
    height: 40,
    borderRadius: theme.borderRadius.s,
    backgroundColor: colors.cartBackground,
  },
  title: {
    flexShrink: 1,
  },
  titleRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing[4],
  },
}));
